module.exports = [{
      plugin: require('/Users/minghuasun/Documents/Github/budget/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TMRP23D","includeInDevelopment":true,"gtmAuth":"SqaRxg0f_r1SEHJc735cxA","gtmPreview":"env-2"},
    },{
      plugin: require('/Users/minghuasun/Documents/Github/budget/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/minghuasun/Documents/Github/budget/budgets/govbudget/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
